import { ActionType, createAction } from 'typesafe-actions';
import { IFavoritesState } from './favorites-reducer';

export const favoritesActions = {
    setItems: createAction('FAVORITES_SET_ITEMS')<IFavoritesState['items']>()
};

export type TFavoritesActions = ActionType<typeof favoritesActions>;
